module.exports = __webpack_public_path__ + "static/media/linkedin.ec019f89.svg";